import { StatusColor } from '../constants/design_system/statusColors';

export enum TaskStatusGroup {
  notStarted = 'notStarted',
  inProgress = 'inProgress',
  completed = 'completed',
}

export type TaskStatus = {
  id: number;
  group: TaskStatusGroup;
  title: string;
  color: 'grey' | 'blue' | 'yellow' | 'orange' | 'red' | 'purple' | 'green';
  default: boolean;
  workspaceId?: number;
  orderIndex?: number;
};

export enum DefaultTaskStatusLabel {
  ToDo = 'To Do',
  InProgress = 'In Progress',
  Blocked = 'Blocked',
  Review = 'Review',
  Done = 'Done',
}

export const defaultTaskStatuses: TaskStatus[] = [
  {
    id: 0,
    group: TaskStatusGroup.notStarted,
    title: DefaultTaskStatusLabel.ToDo,
    color: 'grey',
    default: true,
  },
  {
    id: 1,
    group: TaskStatusGroup.inProgress,
    title: DefaultTaskStatusLabel.InProgress,
    color: 'yellow',
    default: false,
  },
  {
    id: 2,
    group: TaskStatusGroup.inProgress,
    title: DefaultTaskStatusLabel.Blocked,
    color: 'red',
    default: false,
    workspaceId: 0,
  },
  {
    id: 3,
    group: TaskStatusGroup.inProgress,
    title: DefaultTaskStatusLabel.Review,
    color: 'purple',
    default: false,
  },
  {
    id: 4,
    group: TaskStatusGroup.completed,
    title: DefaultTaskStatusLabel.Done,
    color: 'green',
    default: false,
  },
];

/**
 * Single source of truth for status display order — used by the status property
 * dropdown and the filter panel so they match the "manage statuses" order
 * (#2411). Sorts by orderIndex (falling back to id) within each group; callers
 * group by `group` afterwards, so the relative per-group order is what matters.
 */
export const sortTaskStatusesByOrder = (statuses: TaskStatus[]): TaskStatus[] =>
  [...statuses].sort((a, b) => (a.orderIndex ?? a.id) - (b.orderIndex ?? b.id));

export const TaskStatusGroupUtils = {
  getColor(group: TaskStatusGroup): StatusColor {
    switch (group) {
      case TaskStatusGroup.notStarted:
        return StatusColor.grey;
      case TaskStatusGroup.inProgress:
        return StatusColor.yellow;
      case TaskStatusGroup.completed:
        return StatusColor.green;
    }
  },
  getTitle(group: TaskStatusGroup): string {
    switch (group) {
      case TaskStatusGroup.notStarted:
        return 'Not Started';
      case TaskStatusGroup.inProgress:
        return 'In Progress';
      case TaskStatusGroup.completed:
        return 'Completed';
    }
  },
};
